export default "__VITE_ASSET__4a1bf72a__"